import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartOrderEntityParams {
  distributorId: number;
  orderId: number;
}

export class CartOrderEntity extends BaseEntityClass {
  distributorId: number;
  orderId: number;
  constructor(params: CartOrderEntityParams) {
    super();
    this.type = "cart_order";
    this.entity_version = 2;
    this.distributorId = params.distributorId;
    this.orderId = params.orderId;
  }
}
